import React from 'react';
import {Button, Typography} from '@material-ui/core';
import {Link} from 'react-navi';
import useStyles from './CallToAction.styles';

export default function ({title, text, button}) {
    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <Typography
                className={classes['__title']}
                variant="h2"
                component="p"
            >
                {title}
            </Typography>
            {text ? (
                <Typography
                    className={classes['__text']}
                    variant="subtitle1"
                    component="p"
                >
                    {text}
                </Typography>
            ) : null}
            {button ? (
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    href={button.link}
                >
                    {button.label}
                </Button>
            ) : null}
        </div>
    );
}
